import authorizedAxios from "../../helpers/authorizedAxios";
import { showToast } from "../../utils/helpers/ShowToast";

export const SET_FIXED_ASSETS = "SET_FIXED_ASSETS";
export const SET_FIXED_ASSET_DETAIL = "SET_FIXED_ASSET_DETAIL";
export const SET_FIXED_ASSET_LOADING = "SET_FIXED_ASSET_LOADING";
export const SET_FIXED_ASSET_ACTION_LOADING = "SET_FIXED_ASSET_ACTION_LOADING";
export const SET_FIXED_ASSET_ERROR = "SET_FIXED_ASSET_ERROR";

const errorMessage = (error, fallback) => error?.response?.data?.message || error?.userMessage || error?.message || fallback;
const setError = (dispatch, error, fallback) => dispatch({ type: SET_FIXED_ASSET_ERROR, error: errorMessage(error, fallback) });

const mutate = (request, messages) => async (dispatch) => {
  dispatch({ type: SET_FIXED_ASSET_ACTION_LOADING, status: true });
  try {
    const response = await showToast(request(), {
      ...messages,
      error: (error) => errorMessage(error, messages.error),
    });
    return response?.data?.data ?? true;
  } catch (error) {
    setError(dispatch, error, messages.error);
    return null;
  } finally {
    dispatch({ type: SET_FIXED_ASSET_ACTION_LOADING, status: false });
  }
};

export const fetchFixedAssets = (params = {}) => async (dispatch) => {
  dispatch({ type: SET_FIXED_ASSET_LOADING, status: true });
  try {
    const response = await authorizedAxios.get("/fixed-assets", { params });
    dispatch({ type: SET_FIXED_ASSETS, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error, "Data aset gagal dimuat.");
    return null;
  } finally {
    dispatch({ type: SET_FIXED_ASSET_LOADING, status: false });
  }
};

export const fetchFixedAssetDetail = (id) => async (dispatch) => {
  dispatch({ type: SET_FIXED_ASSET_LOADING, status: true });
  try {
    const response = await authorizedAxios.get(`/fixed-assets/${id}`);
    dispatch({ type: SET_FIXED_ASSET_DETAIL, data: response?.data?.data });
    return response?.data?.data;
  } catch (error) {
    setError(dispatch, error, "Detail aset gagal dimuat.");
    return null;
  } finally {
    dispatch({ type: SET_FIXED_ASSET_LOADING, status: false });
  }
};

export const addFixedAsset = (payload) => mutate(
  () => authorizedAxios.post("/fixed-assets", payload),
  { loading: "Mencatat aset...", success: "Aset dan jadwal penyusutan berhasil dicatat.", error: "Aset gagal dicatat." },
);

export const updateFixedAsset = (id, payload) => mutate(
  () => authorizedAxios.put(`/fixed-assets/${id}`, payload),
  { loading: "Memperbarui informasi aset...", success: "Informasi aset berhasil diperbarui.", error: "Informasi aset gagal diperbarui." },
);

export const cancelFixedAsset = (id, reason) => mutate(
  () => authorizedAxios.post(`/fixed-assets/${id}/cancel`, { reason }),
  { loading: "Membatalkan aset...", success: "Aset dibatalkan dan saldo dikembalikan.", error: "Aset gagal dibatalkan." },
);
